import React from "react";

import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
import CategoryIcon from "@mui/icons-material/Category";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import PaidIcon from "@mui/icons-material/Paid";
import PaymentsIcon from "@mui/icons-material/Payments";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
// icons
export const items = {
  text: [
    "home",
    "profile",
    "users",
    "categories",
    "products",
    "orders",
    "invoices",
    "sales",
    "administrators",
    "logOut"
  ],
  icons: [
    <HomeIcon />,
    <AccountCircleIcon />,
    <GroupIcon />,
    <CategoryIcon />,
    <ProductionQuantityLimitsIcon />,
    <PaidIcon />,
    <PaymentsIcon />,
    <CreditScoreIcon />,
    <AdminPanelSettingsIcon />,
    <ExitToAppIcon/>
  ],
};
